import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { Clock, Crown, AlertTriangle } from 'lucide-react';

const SubscriptionBanner = () => {
  const { isAuthenticated, isPro, getTrialDaysLeft, isSubscriptionActive } = useAuth();
  
  if (!isAuthenticated || isPro) return null;
  
  const trialDaysLeft = getTrialDaysLeft();
  const isActive = isSubscriptionActive();
  
  if (isActive && trialDaysLeft > 3) return null;

  const isExpired = !isActive;
  const isUrgent = trialDaysLeft !== null && trialDaysLeft <= 2;

  return (
    <div className={`relative z-20 py-2 px-4 ${
      isExpired 
        ? 'bg-destructive/20 border-b border-destructive/30' 
        : isUrgent 
          ? 'bg-warning/20 border-b border-warning/30'
          : 'bg-primary/10 border-b border-primary/30'
    }`}>
      <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2">
          {isExpired ? (
            <AlertTriangle className="w-4 h-4 text-destructive" />
          ) : isUrgent ? (
            <Clock className="w-4 h-4 text-warning" />
          ) : (
            <Clock className="w-4 h-4 text-primary" />
          )}
          <span className="text-sm">
            {isExpired 
              ? 'Your trial has expired. Upgrade to continue creating content.'
              : `${trialDaysLeft} day${trialDaysLeft !== 1 ? 's' : ''} left in your trial - Upgrade to Pro for unlimited access!`
            }
          </span>
        </div>
        <Link to="/pricing">
          <Button size="sm" variant={isExpired ? 'destructive' : 'gradient'}>
            <Crown className="w-4 h-4 mr-1" />
            Upgrade Now
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default SubscriptionBanner;
